import React from 'react'
import { withCookies } from 'react-cookie'

import { Spin } from 'antd'
import { Toast } from 'antd-mobile'

import { _loginByCode } from '../../server'
import { isQiyeweixin } from '../ShareUtils'

// ww42250e5796a5283a 新动传媒
// wx048a740b5cdc1c0d 云宝
const redirect_uri =
  'https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww42250e5796a5283a&redirect_uri=' +
  encodeURI(process.env.MAIN_HOST) +
  '&response_type=code&scope=snsapi_base#wechat_redirect'

class LoginPage extends React.Component {
  code

  constructor(props) {
    super(props)
    this.state = { isLoading: true }
    let strSearch = window.location.search
    if (!strSearch) {
      strSearch = this.props.location.state
        ? this.props.location.state.params
        : ''
    }
    if (strSearch) {
      let params = strSearch.substring(1, strSearch.length).split('&')
      if (params) {
        params.map((item, i) =>
          item.split('=')[0] === 'code' ? (this.code = item.split('=')[1]) : ''
        )
        if (this.code) {
          this.loginByCode()
        } else {
          Toast.info('参数错误', 1)
        }
      } else {
        this.clearToken()
      }
    } else {
      this.clearToken()
    }
  }

  clearToken() {
    const { cookies } = this.props
    cookies.set(process.env.TOKEN_KEY, '', { path: '/' })
    if (isQiyeweixin()) {
      window.location.href = redirect_uri
    } else {
      window.location.href = process.env.MAIN_HOST + 'pclogin'
    }
  }

  async loginByCode() {
    const res = await _loginByCode(this.code)
    if (res.code === 0) {
      this.setToken(res.data.sid)
    } else {
      Toast.fail('登录失败')
    }
    this.setState({ isLoading: false })
  }

  redirectTo() {
    let RedirectUrl = this.props.location.state
      ? this.props.location.state.from.pathname
      : '/'
    if (window.location.search) {
      RedirectUrl += window.location.search
    }
    // 登陆成功之后的跳转
    this.props.history.push(RedirectUrl)
  }

  setToken(token) {
    const { cookies } = this.props
    cookies.set(process.env.TOKEN_KEY, token, { path: '/' })

    this.redirectTo()
  }

  render() {
    return (
      <div>
        {this.state.isLoading ? (
          <Spin
            tip={'追逐梦想，加油！'}
            style={{ width: '100%', marginTop: '70%' }}
            size="large"
          />
        ) : (
          ''
        )}
      </div>
    )
  }
}

export default withCookies(LoginPage)

